var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.354,
    height: 29.156,
    viewBox: "0 0 45.354 29.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-people",
    "data-name": "Icon ionic-md-people",
    d: "M33.173,20.024a6.149,6.149,0,0,0,6.185-6.074,6.186,6.186,0,0,0-12.369,0A6.148,6.148,0,0,0,33.173,20.024Zm-16.492,0a6.148,6.148,0,0,0,6.185-6.074,6.186,6.186,0,0,0-12.369,0A6.149,6.149,0,0,0,16.681,20.024Zm0,4.454c-4.845,0-14.431,2.328-14.431,7.087v5.467H31.406V31.565C31.406,26.806,21.526,24.478,16.681,24.478Zm16.492,1.114a11,11,0,0,0-1.767.1c2.372,1.721,3.24,2.835,3.24,5.872v5.467H47.6V31.565C47.6,26.806,38.018,25.592,33.173,25.592Z",
    transform: "translate(-2.25 -7.875)",
    fill: "rgb(132, 170, 255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.83ea3b8fd97ea7a2c9fa6ad60fb8895e.svg";
export { ForwardRef as ReactComponent };